export default "__VITE_PUBLIC_ASSET__4572563c__"